// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- Building the DS */
/* KINDS */
.Typography-module__Heading1__CSZEW {
    font-weight: var(--ds-font-weight-bold);
    font-size: var(--ds-heading-1);
    font-family: var(--ds-font-family);
    line-height: var(--ds-line-height-heading);
}

.Typography-module__Heading2__RgIqc {
    font-weight: var(--ds-font-weight-bold);
    font-size: var(--ds-heading-2);
    font-family: var(--ds-font-family);
    line-height: var(--ds-line-height-heading);
}

.Typography-module__Heading3__DFibT {
    font-weight: var(--ds-font-weight-bold);
    font-size: var(--ds-heading-3);
    font-family: var(--ds-font-family);
    line-height: var(--ds-line-height-heading);
}

.Typography-module__Heading4__xYEzK {
    font-weight: var(--ds-font-weight-bold);
    font-size: var(--ds-heading-4);
    font-family: var(--ds-font-family);
    line-height: var(--ds-line-height-heading);
}

.Typography-module__Heading5__m619o {
    font-weight: var(--ds-font-weight-bold);
    font-size: var(--ds-heading-5);
    font-family: var(--ds-font-family);
    line-height: var(--ds-line-height-heading);
}

.Typography-module__Subtitle__sfz7E {
    font-weight: var(--ds-font-weight-bold);
    font-size: var(--ds-subtitle);
    font-family: var(--ds-font-family);
    line-height: var(--ds-line-height-heading);
    letter-spacing: var(--ds-letter-spacing-subtitle);
    text-transform: uppercase;
}

.Typography-module__Paragraph2XLarge__FFqMB {
    font-weight: var(--ds-font-weight-medium);
    font-size: var(--ds-text-2Xlarge);
    font-family: var(--ds-font-family);
    line-height: var(--ds-line-height-paragraph);
    overflow-wrap: anywhere;
}

.Typography-module__ParagraphXLarge__OueYd {
    font-weight: var(--ds-font-weight-medium);
    font-size: var(--ds-text-xlarge);
    font-family: var(--ds-font-family);
    line-height: var(--ds-line-height-paragraph);
    overflow-wrap: anywhere;
}

.Typography-module__ParagraphLarge__pXh4o {
    font-weight: var(--ds-font-weight-medium);
    font-size: var(--ds-text-large);
    font-family: var(--ds-font-family);
    line-height: var(--ds-line-height-paragraph);
    overflow-wrap: anywhere;
}

.Typography-module__ParagraphDefault__tQO5y {
    font-weight: var(--ds-font-weight-medium);
    font-size: var(--ds-text);
    font-family: var(--ds-font-family);
    line-height: var(--ds-line-height-paragraph);
    overflow-wrap: anywhere;
}

.Typography-module__ParagraphSmall__UtEky {
    font-weight: var(--ds-font-weight-medium);
    font-size: var(--ds-text-small);
    font-family: var(--ds-font-family);
    line-height: var(--ds-line-height-paragraph);
    overflow-wrap: anywhere;
}

.Typography-module__ParagraphTiny__tFext {
    font-weight: var(--ds-font-weight-medium);
    font-size: var(--ds-text-tiny);
    font-family: var(--ds-font-family);
    line-height: var(--ds-line-height-paragraph);
    overflow-wrap: anywhere;
}

.Typography-module__Label__Tir0h {
    min-width: 0;
    max-width: 100%;
    overflow: clip visible;
    font-weight: var(--ds-font-weight-medium);
    font-size: var(--ds-text-small);
    font-family: var(--ds-font-family);
    /* To prevent shift when with/without tooltip icon
    we use the icon height as a line height here:
    */
    line-height: var(--ds-5x);
    white-space: nowrap;
    text-overflow: ellipsis;
}

.Typography-module__GenericBig__K6Xd8 {
    min-width: 0;
    max-width: 100%;
    overflow: clip visible;
    font-weight: var(--ds-font-weight-medium);
    font-size: var(--ds-text-big);
    font-family: var(--ds-font-family);
    line-height: var(--ds-line-height);
    white-space: nowrap;
    text-overflow: ellipsis;
}

.Typography-module__Generic__CPhq8 {
    min-width: 0;
    max-width: 100%;
    overflow: clip visible;
    font-weight: var(--ds-font-weight-medium);
    font-size: var(--ds-text);
    font-family: var(--ds-font-family);
    line-height: var(--ds-line-height);
    white-space: nowrap;
    text-overflow: ellipsis;
}

.Typography-module__GenericSmall__WGGwQ {
    min-width: 0;
    max-width: 100%;
    overflow: clip visible;
    font-weight: var(--ds-font-weight-medium);
    font-size: var(--ds-text-small);
    font-family: var(--ds-font-family);
    line-height: var(--ds-line-height);
    white-space: nowrap;
    text-overflow: ellipsis;
}

.Typography-module__GenericTiny__hy8PF {
    min-width: 0;
    max-width: 100%;
    overflow: clip visible;
    font-weight: var(--ds-font-weight-medium);
    font-size: var(--ds-text-tiny);
    font-family: var(--ds-font-family);
    line-height: var(--ds-line-height);
    white-space: nowrap;
    text-overflow: ellipsis;
}
/* COLORS */
.Typography-module__DefaultColor__Jhng3 {
    color: var(--ds-font-color);
}

.Typography-module__AccentColor__uGbdM {
    color: var(--ds-font-color-accent);
}

.Typography-module__MutedColor__ecso8 {
    color: var(--ds-font-color-muted);
}

.Typography-module__InvertedColor__xZtxS {
    color: var(--ds-font-color-inverted);
}

.Typography-module__AlertColor__izqLv {
    color: var(--ds-font-color-alert);
}

.Typography-module__InformativeColor__sri5V {
    color: var(--ds-font-color-informative);
}

.Typography-module__PositiveColor__WGF4Q {
    color: var(--ds-font-color-positive);
}

.Typography-module__NegativeColor__mnDmm {
    color: var(--ds-font-color-negative);
}

.Typography-module__InheritColor__SGKiC {
    color: inherit;
}
/* ALIGNMENTS */
.Typography-module__AlignInherit__U7CFc {
    text-align: inherit;
}

.Typography-module__AlignLeft__raPs7 {
    text-align: left;
}

.Typography-module__AlignRight__zkXnR {
    text-align: right;
}

.Typography-module__AlignCenter__c6xwR {
    text-align: center;
}
/* DECORATIONS */
.Typography-module__Uppercase__aHD3D {
    text-transform: uppercase;
}
/* FONT WEIGHTS */
.Typography-module__Regular__Kv6HV {
    font-weight: var(--ds-font-weight-regular);
}

.Typography-module__Medium__duNlB {
    font-weight: var(--ds-font-weight-medium);
}

.Typography-module__Bold__KF8v4 {
    font-weight: var(--ds-font-weight-bold);
}

.Typography-module__BreakAll__f9mq1 {
    word-break: break-all;
}

.Typography-module__BreakWord__PDPEh {
    overflow-wrap: break-word;
}

.Typography-module__Truncatable__WCEr5 {
    min-width: 0;
    overflow: clip visible;
    white-space: nowrap;
    text-overflow: ellipsis;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Heading1": `Typography-module__Heading1__CSZEW`,
	"Heading2": `Typography-module__Heading2__RgIqc`,
	"Heading3": `Typography-module__Heading3__DFibT`,
	"Heading4": `Typography-module__Heading4__xYEzK`,
	"Heading5": `Typography-module__Heading5__m619o`,
	"Subtitle": `Typography-module__Subtitle__sfz7E`,
	"Paragraph2XLarge": `Typography-module__Paragraph2XLarge__FFqMB`,
	"ParagraphXLarge": `Typography-module__ParagraphXLarge__OueYd`,
	"ParagraphLarge": `Typography-module__ParagraphLarge__pXh4o`,
	"ParagraphDefault": `Typography-module__ParagraphDefault__tQO5y`,
	"ParagraphSmall": `Typography-module__ParagraphSmall__UtEky`,
	"ParagraphTiny": `Typography-module__ParagraphTiny__tFext`,
	"Label": `Typography-module__Label__Tir0h`,
	"GenericBig": `Typography-module__GenericBig__K6Xd8`,
	"Generic": `Typography-module__Generic__CPhq8`,
	"GenericSmall": `Typography-module__GenericSmall__WGGwQ`,
	"GenericTiny": `Typography-module__GenericTiny__hy8PF`,
	"DefaultColor": `Typography-module__DefaultColor__Jhng3`,
	"AccentColor": `Typography-module__AccentColor__uGbdM`,
	"MutedColor": `Typography-module__MutedColor__ecso8`,
	"InvertedColor": `Typography-module__InvertedColor__xZtxS`,
	"AlertColor": `Typography-module__AlertColor__izqLv`,
	"InformativeColor": `Typography-module__InformativeColor__sri5V`,
	"PositiveColor": `Typography-module__PositiveColor__WGF4Q`,
	"NegativeColor": `Typography-module__NegativeColor__mnDmm`,
	"InheritColor": `Typography-module__InheritColor__SGKiC`,
	"AlignInherit": `Typography-module__AlignInherit__U7CFc`,
	"AlignLeft": `Typography-module__AlignLeft__raPs7`,
	"AlignRight": `Typography-module__AlignRight__zkXnR`,
	"AlignCenter": `Typography-module__AlignCenter__c6xwR`,
	"Uppercase": `Typography-module__Uppercase__aHD3D`,
	"Regular": `Typography-module__Regular__Kv6HV`,
	"Medium": `Typography-module__Medium__duNlB`,
	"Bold": `Typography-module__Bold__KF8v4`,
	"BreakAll": `Typography-module__BreakAll__f9mq1`,
	"BreakWord": `Typography-module__BreakWord__PDPEh`,
	"Truncatable": `Typography-module__Truncatable__WCEr5`
};
export default ___CSS_LOADER_EXPORT___;
